import { render } from "./instructor-chat-message.vue?vue&type=template&id=a9ba2ade"
const script = {}

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__